export interface SUPPORT_DOC {
  url: string;
  type: string;
  name: string;
}

export const SUPPORT_DOC_ID = '1';
export const PV_DOC_ID = '2';
export const SUPPORT_DOC_JUDGEMENT_ADD_ID = '2';
export const SUPPORT_DOC_EXPERT_REPORT_ID = '3';
export const SUPPORT_DOC_JUDGEMENT_ON_MERITS_ID = '4';
export const EMPTY_SUPPORT_DOC: SUPPORT_DOC = {
  url: '',
  name: '',
  type: '',
};
